export default __webpack_public_path__ + "static/vitamin-e-ea17ba579a2ecd5e2f97dd88cc87e0cd.jpg";